
export default{
    data() {
        return {
            apis:{
                add:'sh/comment/add',//添加评论
                total:'sh/comment/total',//获取评论总数
                tree:'sh/comment/tree',//获取评论树
            },
            userKey:null,//当前登录用户主键
            editObj:{},//编辑对象
            params:{
                status: 2,//仅仅获取已通过审核的
            },
            total:0,
            comments:[],
            curComment:null,
            replay:{//回复内容对象
                content:null
            },
        }
    },
    props:{
        bizType:{//业务分类
            type: Number,
            default: null
        },
        bizKey:null,//业务主键
        bizTypeName:null,//业务分类名称
        bizName:null,//业务名称
        bizCover:null,//业务封面
    },
    mounted() {
        this.userKey = sessionStorage.getItem(this.$global.userKey);
        this.getTotal();
        this.loadComments();
    },
    methods: {
        save(){//添加评论
            const me = this;
            if(!me.bizType || !me.bizKey){
                return;
            }
            if(!me.userKey){
                me.$message.error('请先登录');
                return;
            }
            me.$set(me.editObj, 'userKey', me.userKey);
            me.$set(me.editObj, 'bizType', me.bizType);
            me.$set(me.editObj, 'bizTypeName', me.bizTypeName);
            me.$set(me.editObj, 'bizKey', me.bizKey);
            me.$set(me.editObj, 'bizName', me.bizName);
            me.$set(me.editObj, 'bizCover', me.bizCover);
            me.$post({
                url: me.apis.add,
                params: me.editObj
            }).then(rsp => {
                if(rsp.success){
                    me.$message.success('回复成功');
                    me.getTotal();
                    me.loadComments();
                    me.editObj = {};
                }
            })
        },
        getTotal(){//获取评论总数
            const me = this;
            if(!me.bizType || !me.bizKey){
                me.total = 0;
                return;
            }
            me.$post({
                url: me.apis.total,
                params:{
                    bizType: me.bizType,
                    bizKey: me.bizKey,
                    status: 2,//仅仅获取通过审核的
                }
            }).then(rsp => {
                if(rsp.success){
                    me.total = rsp.retObj;
                }
            })
        },
        loadComments(){
            const me = this;
            if(!me.bizType || !me.bizKey){
                me.total = 0;
                return;
            }
            me.$post({
                url: me.apis.tree,
                params:{
                    bizType: me.bizType,
                    bizKey: me.bizKey,
                    status: 2,//仅仅获取通过审核的
                }
            }).then(rsp => {
                if(rsp.success){
                    me.comments = rsp.retObj;
                }
            })
        },
        showInput(comment){//显示对回复的评论
            this.curComment = comment;
        },
        saveReplay(){//对回复添加评论
            const me = this;
            if(!me.userKey){
                me.$message.error('请先登录');
                return;
            }
            me.$set(me.replay, 'bizName', '回复【'+ me.curComment.bizName +'】的评论【' + me.curComment.id + '】');
            me.$set(me.replay, 'parentKey', me.curComment.id);
            me.$post({
                url: me.apis.add,
                params: me.replay
            }).then(rsp => {
                if(rsp.success){
                    me.$message.success('回复成功');
                    me.curComment = null;
                    me.loadComments();
                }
            })
        },
        saved(){//子评论保存成功后刷新评论列表
            this.loadComments();
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/base/view/interact/cmps/comment/web/src/web.js